import { HTTPMethod } from "namirasoft-core";
import { SwaggerTypeBuilder } from "./SwaggerTypeBuilder";
import { ControllerSchema } from "./schema/ControllerSchema";
import { StringSchema } from "./schema/type/StringSchema";
import { BaseVariableSchema } from "./schema/BaseVariableSchema";

export class SwaggerControllerBuilder 
{
    private schema: ControllerSchema;
    constructor(schema: ControllerSchema)
    {
        this.schema = schema;
    }
    runSynch(): string[]
    {
        let lines: string[] = [];
        lines.push(`/**`);
        lines.push(` * @swagger`);
        lines.push(` * ${this.schema.path}:`);
        lines.push(` *   ${HTTPMethod[this.schema.method].toString().toLowerCase()}:`);
        lines.push(` *     summary: ${this.schema.summary}`);
        lines.push(` *     tags:`);
        lines.push(` *       - ${this.schema.tag}`);
        if (this.schema.headers.length + this.schema.parameters.length + this.schema.queries.length > 0)
        {
            let addParameter: (name: string, ps: BaseVariableSchema[]) => Promise<void> = async (name, ps) =>
            {
                for (let i = 0; i < ps.length; i++)
                {
                    const p = ps[i];
                    lines.push(` *       - in: ${name}`);
                    lines.push(` *         name: ${p.name}`);
                    lines.push(` *         required: ${p.type.required}`);
                    lines.push(` *         schema:`);
                    let line = ` *           `;
                    let builder = new SwaggerTypeBuilder(p.type, true, lines, line);
                    builder.runSynch(() => { });
                }
            };
            lines.push(` *     parameters:`);
            addParameter("header", this.schema.headers);
            addParameter("path", this.schema.parameters);
            addParameter("query", this.schema.queries);
        }
        if (this.schema.body)
        {
            lines.push(` *     requestBody:`);
            lines.push(` *       required: ${(this.schema.body.required)}`);
            lines.push(` *       content:`);
            lines.push(` *         application/json:`);
            lines.push(` *           schema:`);
            let line = ` *             `;
            let builder = new SwaggerTypeBuilder(this.schema.body, true, lines, line);
            builder.runSynch(() => { });
            lines.push(` *         application/schema:`);
            lines.push(` *           example: ""`);
        }
        let output = this.schema.output ?? new StringSchema(true).addValid("Success");
        lines.push(` *     responses:`);
        lines.push(` *       200:`);
        lines.push(` *         description: OK`);
        lines.push(` *         content:`);
        lines.push(` *           application/json:`);
        lines.push(` *             schema:`);
        let line = ` *               `;
        let builder = new SwaggerTypeBuilder(output, true, lines, line);
        builder.runSynch(() => { });
        lines.push(` *           application/schema:`);
        lines.push(` *             schema:`);
        lines.push(` *               type: object`);
        lines.push(` *               additionalProperties: true`);
        lines.push(` */`);
        return lines;
    }
}